import { render, staticRenderFns } from "./EditAccount.vue?vue&type=template&id=b4d9a832&scoped=true&"
import script from "./EditAccount.vue?vue&type=script&lang=js&"
export * from "./EditAccount.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/form.css?vue&type=style&index=0&id=b4d9a832&prod&scoped=true&lang=css&"
import style1 from "./EditAccount.vue?vue&type=style&index=1&id=b4d9a832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d9a832",
  null
  
)

export default component.exports